import { Directive, Input, HostListener } from '@angular/core';
import { AnalyticService } from 'src/app/core/services/google-analytics.service';

@Directive({
  selector: '[appTrackEvent]'
})
export class TrackEventDirective {
  @Input('appTrackEvent') eventName = '';

  constructor(private analyticService: AnalyticService) {}

  @HostListener('click')
  onClick() {
    this.analyticService.sendEvent(this.eventName);
  }
}
